/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Change_Pw_BtnInputs */

const vi_user_change_pw_btn = /** @type {(inputs: User_Change_Pw_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi MK`)
};

/**

* @param {User_Change_Pw_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const user_change_pw_btn = /** @type {((inputs?: User_Change_Pw_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Change_Pw_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_user_change_pw_btn(inputs)
});